import React, { useEffect } from 'react';

const IncomingCall = ({ incomingData, onAccept, onDecline }) => {
    useEffect(() => {
        // Create a synthetic ringtone using Web Audio API
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        const ctx = new AudioContext();
        let osc, gain;
        let intervalId;

        const ring = () => {
            if (ctx.state === 'suspended') {
                ctx.resume();
            }
            osc = ctx.createOscillator();
            gain = ctx.createGain();
            osc.type = 'sine';
            osc.frequency.setValueAtTime(440, ctx.currentTime);
            osc.frequency.setValueAtTime(480, ctx.currentTime + 0.1);
            
            gain.gain.setValueAtTime(0, ctx.currentTime);
            gain.gain.linearRampToValueAtTime(0.5, ctx.currentTime + 0.1);
            gain.gain.linearRampToValueAtTime(0, ctx.currentTime + 0.8);
            
            osc.connect(gain);
            gain.connect(ctx.destination);
            osc.start();
            osc.stop(ctx.currentTime + 1);
        };

        ring();
        intervalId = setInterval(ring, 2000);

        return () => {
            clearInterval(intervalId);
            ctx.close();
        };
    }, []);

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(10px)',
            zIndex: 1500, display: 'flex', flexDirection: 'column', 
            justifyContent: 'center', alignItems: 'center'
        }}>
            <div style={{ padding: '40px', textAlign: 'center', background: '#202124', borderRadius: '15px' }}>
                <h2 style={{ color: 'white', marginBottom: '10px' }}>Incoming {incomingData.isVideo ? 'Video' : 'Audio'} Call</h2>
                <h3 style={{ color: '#8ab4f8', marginBottom: '30px', fontSize: '1.5rem' }}>from {incomingData.callerName}</h3>
                
                <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
                    <button 
                        onClick={onDecline} 
                        style={{ padding: '15px 30px', borderRadius: '30px', background: '#ea4335', color: 'white', border: 'none', cursor: 'pointer', fontSize: '1.1rem', fontWeight: 'bold' }}
                    >
                        Decline
                    </button>
                    <button 
                        onClick={onAccept} 
                        style={{ padding: '15px 30px', borderRadius: '30px', background: '#34a853', color: 'white', border: 'none', cursor: 'pointer', fontSize: '1.1rem', fontWeight: 'bold' }}
                    >
                        Accept
                    </button>
                </div>
            </div>
        </div>
    );
};

export default IncomingCall;
